
        <div class="grouping-wrapper">
            <span class="divider"></span>
            <span class="grouping-hint" *ngIf="groups.length">Group by:</span>
            <div class="drop-target"
                 [class.drag-over]="isDragOver"
                 (dragover)="onDragOver($event)"
                 (dragleave)="onDragLeave()"
                 (dragenter)="onDragEnter()"
                 (drop)="onDrop($event)">
        <span *ngIf="groups.length === 0 && placeholderIndex == null" class="group-empty-state">
            <span class="hint">Drop column header here to group the list</span>
        </span>
                <div #groupFlexWrapper class="group-flex-wrapper" *ngIf="groups.length > 0 || placeholderIndex === 0"
                     [ngStyle]="groupElementMaxWidth ? { 'max-width': groupElementMaxWidth + 'px' } : {}">
                    <ng-container *ngIf="groups.length > 0; else noGroups">
                        <div cdkDropList
                             [cdkDropListData]="visibleGroups"
                             (cdkDropListDropped)="onPillDrop($event)"
                             cdkDropListOrientation="horizontal"
                             class="group-pills-droplist">
                            <ng-container *ngFor="let group of visibleGroups; let i = index">
                                <div #placeHolder
                                     class="group-placeholder"
                                     *ngIf="placeholderIndex === i"
                                     (dragover)="onDragOver($event)"
                                ></div>
                                <div
                                    #groupLabel
                                    cdkDrag
                                    class="group-label"
                                    (dragover)="onDragOver($event)">
                                    {{ group.headerName }}
                                    <i class="fa fa-times" (click)="removeGroup(i)" style="cursor: pointer; margin-left: 6px;"></i>
                                </div>
                            </ng-container>
                        </div>
                        <div [class.group-placeholder]="isDragOver"
                             (dragover)="onDragOver($event)"
                             *ngIf="placeholderIndex === visibleGroups.length"
                        ></div>
                        <div #dropDownElement class="pos-rlt fx-layout-row fx-align--x-center group-dropDown" dropdown *ngIf="dropdownGroups.length > 0">
                            <button dropdownToggle type="button" class="btn group-label group-dropdown-btn">
                                <span>+{{ dropdownGroups.length }}</span>
                                <i class="fa-solid fa-angle-down"></i>
                            </button>
                            <div *dropdownMenu class="dropdown-menu more-group">
                                <span class="cs-caret cs-border-top cs-border-left"></span>
                                <div class="dropdown-groups-container">
                                <span *ngFor="let group of dropdownGroups; let i = index"
                                      class="group-label dropdown-group-item">
                                    <span class="group-text">{{ group.headerName }}</span>
                                    <i class="fa fa-times"
                                       (click)="removeDropdownGroup(i)"
                                       style="cursor: pointer; margin-left: 6px;"></i>
                                </span>
                                </div>
                            </div>
                        </div>
                        <div
                            style="flex: 1"
                            (dragover)="onDragOver($event)"
                            *ngIf="placeholderIndex === visibleGroups.length"
                        ></div>
                    </ng-container>
                    <ng-template #noGroups>
                        <div style="display: flex" *ngIf="placeholderIndex === 0">
                            <span class="grouping-hint" style="margin-right: 2px;">Group by:</span>
                            <span class="margin-x-2" [class.group-placeholder]="isDragOver"></span>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    